import { Routes, Route, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";
import PageLoader from "@/components/Loaders/PageLoader";
import { useRouteAuthorization } from "@/hooks/useRouteAuthorization";

const AdminLayout = lazy(() => import("@layout/AdminLayout"));

const MainRoutes = () => {
  const { flatRoutes } = useRouteAuthorization();

  return (
    <Routes>
      <Route element={
        <Suspense fallback={<PageLoader />}>
          <AdminLayout />
        </Suspense>
      }>
        {flatRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              <Suspense fallback={<PageLoader />}>
                <route.component />
              </Suspense>
            }
          />
        ))}

        {/* fallback */}
        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Route>
    </Routes>
  );
};

export default MainRoutes;
